import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MavrixPairsConfigurations } from "@/types";
import { useUserAccounts } from "@trader-dashboard/shared";
import { useDemoAwareAccountData } from "@/data/useDemoAccountData";
import { PairsTable } from './components';

export const PairsPage = (): React.ReactNode => {
  const [error, setError] = useState<string | undefined>(undefined);
  const { accountId } = useParams();
  const {selectedAccountId} = useUserAccounts();

  const { loaded: accountDataLoaded, accountData, error: accountLoadError } = useDemoAwareAccountData();

  useEffect(() => {
    if (accountLoadError) {
      setError(accountLoadError);
    }
  }, [accountLoadError]);

  if (error) return <div>Error: {error}</div>;
  if (!accountDataLoaded || !accountData) return <div>Loading...</div>;

  return (
    <PairsTable
        pairs={accountData.pairs}
        pairConfigurations={MavrixPairsConfigurations}
        totalProfit={accountData.totalProfit}
        showAllPairs={true}
        accountId={accountId || selectedAccountId}
        showTypeColumn={false}
      />
  );
};
